import cx from 'classnames'
import React, { Fragment } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useDispatch, useSelector } from 'react-redux'
import { SelectUIState, UIStateActions } from '../../store/uiState'
import { TransitionGroup } from 'react-transition-group'

interface Props {
  NavContent: any
}

const AppSidebar: React.FC<Props> = ({ NavContent }: Props) => {
  const dispatch = useDispatch()
  const uiState = useSelector(SelectUIState)
  const {
    enableMobileMenu,
    enableBackgroundImage,
    backgroundImage,
    backgroundImageOpacity,
    backgroundColor,
    enableSidebarShadow,
  } = uiState

  return (
    <Fragment>
      <div
        className="sidebar-mobile-overlay"
        onClick={() => dispatch(UIStateActions.setEnableMobileMenu(!enableMobileMenu))}
      />
      <TransitionGroup
        component="div"
        className={cx('app-sidebar', backgroundColor, { 'sidebar-shadow': enableSidebarShadow })}
        classNames="SidebarAnimation"
        appear={true}
        appearTimeout={1500}
        enter={false}
        exit={false}
      >
        <PerfectScrollbar>
          <div className="app-sidebar__inner">
            <NavContent />
          </div>
        </PerfectScrollbar>
        <div
          className={cx('app-sidebar-bg', backgroundImageOpacity)}
          style={{
            backgroundImage: enableBackgroundImage ? 'url(' + backgroundImage + ')' : undefined,
          }}
        ></div>
      </TransitionGroup>
    </Fragment>
  )
}

export default AppSidebar
